<template>
    <div :class="['kit']">

        <div @click="startVideo()" class="sectionTitle black fsTitle">
            {{ms_localize(sectionData.title)}}
            <!-- <splitter :content="ms_localize(sectionData.title)"></splitter> -->
        </div>
        
        <div class="kitContainer">
            <img :src="sectionData.img" />
<!--             <video @click="startVideo()" playsinline autoplay muted id="kitVideo">
                <source :src="getVideoUrl()" type="video/mp4">
            </video>
 -->        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import splitter from "@/views/com/splitter.vue";

export default {
    name: "kit",
    components:{splitter},
    props: {
        sectionDataIndex:Number,
        isNavOpen: Boolean
    },
    data()
    {
        return {selectedIndex:0}
    },
    mounted() {
        //this.initScrollListener();
        var vid = document.getElementById("kitVideo");
        vid.pause();

    },
    destroyed() {
        //this.removeScrollListener();
    },
    methods:
    {
        startVideo()
        {
            //alert("start");
            var vid = document.getElementById("kitVideo");
            vid.play();
        },
        getVideoUrl()
        {
            return this.sectionData.video_path;//  "img/video/MIS_Lance_plus_Con_KIT2.mp4";
        }
    },
    computed:{
      ...mapState(["minisite_data"]),
        sectionData(){ 
            return this.minisite_data.SECTIONS[this.sectionDataIndex];
        }

    }
};
</script>

<style>
    .kit
    {      
        position:relative;
        width: 100vw;
        height: 100%;
        display: grid;
        align-items: center;
        background-color: #fff;
    }    
    .kit .sectionTitle
    {
        position:absolute;
        top:100px;width: 100%;
        z-index: 10000;
    }
    .kit .kitContainer
    {
      margin: auto;position: absolute;
      top:55%;transform: translateY(-50%);
      text-align: center;
      width: 100vw;
    }
    .kit .kitContainer img
    {
      width: auto;
      height: 70vh;
      margin: auto;
    }

    #kitVideo {
      position: absolute;
      z-index: 1;
      left: 50%;
      top:50%;      
      height:80vh;
      transform: translate(-50%,-50%);
    }

  @media (hover: hover) {

  }

  @media (max-width: 850px) {     
    .kit
    {      
        height: auto;
        padding: 0px 0px 0px 0px;
        display: block;        
        min-height: 30vh;
        padding-bottom: 50px;
    }        
    .kit .sectionTitle
    {
        position:static;
        top:0px;
        padding-top:100px;
    }    
    .kit .kitContainer {
        position: initial;
        width: 100vw;
        margin: auto;
        height: auto;
        text-align: center;
        padding-top: 40px;
        clear: both;
        transform: none;
    }
    .kit .kitContainer img {
        width: 90vw;
        height: auto;
        margin: auto;
    }

        #kitVideo {
        position: initial;
        height: 80vw;
        transform: none;
        float: left;
        margin: auto;
        width: 100vw;      
    }    


  }  
</style>

